import React from "react";
import immutiverseLogo from "../assets/icons/Immutaverse+Blue+White+Logo.webp";
import linkedinIcon from "../assets/icons/linkedinIcon.png";
import twitterIcon from "../assets/icons/twitterIcon.png";
import InstagramLLogo from "../assets/icons/InstagramLogo.png";
import '../assets/styles/Footer.css'
import Hackable_Devices_Logo from "../assets/icons/Hackable_Devices_Logo.webp"


const Footer = () => {
  return (
    <div className="custom-footer">
      <div className="footer-container">
        {/* Logo Section */}
        {/* <div className="footer-column logo-column">
          <img
            src={Hackable_Devices_Logo}
            alt="Immutaverse Logo"
            className="footer-logo"
           width="200"
    height="60"
          />
        </div> */}

        {/* Platform Section */}
        {/* <div className="footer-column platform-column">
          <h3>PLATFORM</h3>
          <ul>
            <li><a href="https://www.immutaverse.com/immutaverse-origin">Immutaverse Origin</a></li>
            <li><a href="https://www.immutaverse.com/immutaverse-radar">Immutaverse Radar</a></li>
            <li><a href="https://www.immutaverse.com/immutaverse-regen">Immutaverse Regen</a></li>
          </ul>
        </div> */}

        {/* Solutions Section */}
        {/* <div className="footer-column platform-column">
          <h3>SOLUTIONS</h3>
          <ul>
            <li><a href="https://www.immutaverse.com/new-product-introduction">New Product Introduction</a></li>
            <li><a href="https://www.immutaverse.com/scalable-device-security-workflows">Scalable Device Security Workflows</a></li>
            <li><a href="https://www.immutaverse.com/regulatory-compliance">Regulatory Compliance</a></li>
          </ul>
        </div> */}

        {/* Company Section */}
        {/* <div className="footer-column about-column">
          <h3>COMPANY</h3>
          <ul>
            <li><a href="https://www.immutaverse.com/about">About Us</a></li>
            <li><a href="https://www.immutaverse.com/privacy-policy">Privacy Policy</a></li>
            <li><a href="https://www.immutaverse.com/cookie-policy">Cookie Policy</a></li>
          </ul>
        </div> */}

        {/* Social Section */}
        <div className="footer-column social-column">
          <ul>
            <li>
              <a
                href="https://www.linkedin.com/company/hackable-devices/?viewAsMember=true"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={linkedinIcon} alt="LinkedIn" className="social-icon" />
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/hackabledevices/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={InstagramLLogo} alt="LinkedIn" className="social-icon" />
              </a>
            </li>
            <li>
              <a
                href="https://x.com/HackableDevics"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={twitterIcon} alt="Twitter" className="social-icon" />
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>© 2026 Hackable Devices, Inc.</p>
      </div>
    </div>
  );
};

export default Footer;
